module.exports = __webpack_public_path__ + "img/ic-pin-focused.49caf6c1.svg";